const env = process.env.NODE_ENV === "production" ? (window as any)._env_ : process.env;
export default env;
